import styled from 'styled-components';

export const RowAgencyRankItem = styled.div`
  display: flex;
  font-size: 1.5rem;
  color: #000000;
  margin-bottom: 1.8rem;
  div:nth-child(1) {
    width: 16.625rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 1rem;
  }
`;
export const AgencyHeightList = styled.div`
  height: 26rem;
`;
